import { Reveal } from "@/lib/motion";
import { ArrowRight } from "lucide-react";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const ClosingCTA = () => {
  return (
    <section className="relative py-24 lg:py-32">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="relative overflow-hidden rounded-[20px] bg-[#292414] border border-[#D4AF37]/30 px-8 py-16 lg:px-16 lg:py-24 text-center grain">
            <div className="relative z-10">
              <h2 className="font-head font-black tracking-tight text-[#F8FAFC] text-4xl lg:text-6xl leading-[1.02] max-w-3xl mx-auto">
                Safety is the new standard <span className="text-[#D4AF37]">in real estate.</span>
              </h2>
              <p className="font-body text-[#CBD5E1] text-lg mt-6 max-w-xl mx-auto leading-relaxed">
                Be among the first agents and security providers to join the BodyGuard EXP network.
              </p>
              <button
                onClick={() => scrollTo("#waitlist")}
                data-testid="closing-join-btn"
                className="group mt-10 font-head font-bold text-base bg-[#D4AF37] text-[#050914] px-8 h-[56px] rounded-xl hover:bg-[#E4C569] transition-colors duration-200 inline-flex items-center gap-2"
              >
                Join the Waitlist
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
